import { NgModule } from '@angular/core';

import { ApTabComponent } from './tab/tab.component';
import { ApTabsComponent } from './tabs.component';
import { ApTabLabelDirective } from './tab-label/ap-tab-label.directive';

/**
 * @ngdoc module
 * @name ApTabsModule
 */
@NgModule({
    imports: [ApTabComponent, ApTabsComponent, ApTabLabelDirective],
    exports: [ApTabComponent, ApTabsComponent, ApTabLabelDirective]
})
export class ApTabsModule {}
